import twemoji from 'twemoji'

export default function () {
  document
    .querySelectorAll('#root-nav')
    .forEach(element => {
      twemoji.parse(element)
    })
}